import React from 'react';

import { Card, Label, ListerItem } from '@ergeon/core-components';

import { SkeletonLine } from './SkeletonLine';

const CallInfoSkeleton = () => {
  // Skeleton items matching the real CallInfo data structure (excluding Duration which is live)
  const skeletonItems = [
    { title: <SkeletonLine width="w-12" />, value: <SkeletonLine width="w-16" /> },
    { title: <SkeletonLine width="w-16" />, value: <SkeletonLine width="w-32" /> },
    { title: <SkeletonLine width="w-12" />, value: <SkeletonLine width="w-28" /> },
    { title: <SkeletonLine width="w-10" />, value: <SkeletonLine width="w-40" /> },
    { title: <SkeletonLine width="w-16" />, value: <SkeletonLine width="w-20" /> },
    { title: <SkeletonLine width="w-12" />, value: <SkeletonLine width="w-24" /> },
    { title: <SkeletonLine width="w-20" />, value: <SkeletonLine width="w-36" /> },
  ];

  // Skeleton buttons matching size="small" buttons
  const skeletonButtons = [
    <span className="animate-pulse bg-gray-200 dark:bg-gray-700 h-6 w-40 inline-block rounded" key="btn1" />,
    <span className="animate-pulse bg-gray-200 dark:bg-gray-700 h-6 w-40 inline-block rounded" key="btn2" />,
  ];

  return (
    <Card className="relative flex flex-col gap-3 p-4 w-full" data-testid="call-info-skeleton" flavor="base" zIndex="1">
      <Label>Call Info</Label>
      <ListerItem
        aria-label="Loading call information"
        buttons={skeletonButtons}
        items={skeletonItems}
        title={<SkeletonLine width="w-32" />} />
    </Card>
  );
};

export default CallInfoSkeleton;
